import { isRequiredField } from '@/lib/formik-utils'
import { logger } from '@/lib/logger'
import { WithProps } from '@/types/core-types'
import cards from 'card-validator'
import { CardNumberVerification } from 'card-validator/dist/card-number'
import { Field, FieldHookConfig, FieldValidator, useField, useFormikContext } from 'formik'
import React, { KeyboardEventHandler, useEffect, useState } from 'react'

type CreditCardInputFieldProps = { label?: string; showError?: boolean } & FieldHookConfig<any>
//JSX.IntrinsicElements["input"]
const CreditCardInputInputField: React.FC<CreditCardInputFieldProps> = ({
  className,
  label,
  showError = true,

  ...props
}) => {
  const { setFieldValue, setFieldError, validateField, errors } = useFormikContext()
  const [field, meta, helpers] = useField(props.name)
  const [cardInfo, setCardInfo] = useState<CardNumberVerification>(cards.number(field.value))

  const formatCreditCardNumber = (value: string) => {
    // Remove all non-digit characters
    const numbersOnly = value.replace(/\D/g, '')
    // Add a space every 4 digits
    return numbersOnly.replace(/(\d{4})(?=\d)/g, '$1 ')
  }
  useEffect(() => {
    const formattedValue = formatCreditCardNumber(field.value)
  }, [field.value])

  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event: any) => {
    // Allow for backspace and delete functionality
    if (event.key === 'Backspace' || event.key === 'Delete') {
      // Prevent the default action to manage the cursor position correctly
      event.preventDefault()

      let newValue = field.value
      // If there's a space behind the cursor, adjust the position to remove the digit before the space
      const selectionStart = event.target.selectionStart
      if (field.value[selectionStart - 1] === ' ') {
        newValue = field.value.slice(0, selectionStart - 2) + field.value.slice(selectionStart - 1)
      } else {
        newValue = field.value.slice(0, selectionStart - 1) + field.value.slice(selectionStart)
      }
      //setValue(formatCreditCardNumber(newValue))
      // if (onChange) {
      //onChange(newValue)
      //}
    }
  }
  const mapCardType = (card: string | undefined): string => {
    if (card?.toLowerCase() === 'mastercard') {
      return 'MasterCard'
    }
    if (card?.toLowerCase() === 'american express') {
      return 'AMEX'
    }
    if (card?.toLowerCase() === 'dinersclub') {
      return 'DinersClub'
    }
    if (card?.toLowerCase() === 'jcb') {
      return 'JCB'
    }
    return card ?? ''
  }
  useEffect(() => {
    const data = cards.number(field.value)
    if (data.isPotentiallyValid || data.isValid) {
      let card = data.card?.niceType ?? ''
      card = mapCardType(card)
      setFieldValue('cardType', card)
      helpers.setError('')
    } else {
      setFieldValue('cardType', '')
    }
    validateField(field.name)
  }, [field.value])

  const { error } = meta
  const hasError = meta.touched && meta.error ? true : false
  return (
    <div className={className}>
      <label htmlFor={field.name} className={`block text-sm font-medium text-gray-700`}>
        {label}
        {props.required && <span className="ml-1 text-red-500">*</span>}
      </label>
      <div className="mt-1">
        <input
          {...field}
          className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${
            hasError ? 'border-red-500' : ''
          }`}
          //onKeyDown={handleKeyDown}
        />
        {meta.error && meta.touched && <p className="mt-2 text-sm text-red-500">{meta.error}</p>}
      </div>
    </div>
  )
}

export default CreditCardInputInputField
